import React from "react";
import sterilizationImg from "../../assets/Images/sterilization.jpg"
import tauclaveImg from "../../assets/Images/tauclave.jpg"

const SterilizationComponent = (props) => {
    const { selectedLanguage } = props

    return (
        <div className="main">
            <div className='sterilization-component-container'>
                <div className="sterilization-heading-div">
                    <h3>{selectedLanguage?.txt_sterialixatio_and_higein_protocol_that_we_follow}</h3>
                </div>
                <div className="sterilization-list-div">
                    <ul>
                        <li>{selectedLanguage?.txt_hand_washing_to_reduce_bacteria}</li>
                        <li>{selectedLanguage?.txt_gloves_and_mask_to_prevent_direct}</li>
                        <li>{selectedLanguage?.txt_protective}</li>
                        <li>{selectedLanguage?.txt_approved_disposal}</li>
                        <li>{selectedLanguage?.txt_autoclave_sterilizer}</li>
                    </ul>
                    <ul>
                        <li>{selectedLanguage?.txt_use_of_diposables}</li>
                        <li>{selectedLanguage?.txt_through_cleaning_and_or_seterlization}</li>
                        <li>{selectedLanguage?.txt_surface_disinfection}</li>
                        <li>{selectedLanguage?.txt_selection_of_equipments_designed}</li>
                        <li>{selectedLanguage?.txt_care_and_maintenance_of_dental_units}</li>
                    </ul>
                </div>
                <div className="sterilization-img-div">
                    <img src={sterilizationImg} alt="sterilizationImg" />
                </div>
                <div className="sterilization-bottom-container">
                    <div className="sterilization-bottom-text-div">
                        <p>
                            {selectedLanguage?.txt_each_and_evry_patient_undergoes}
                        </p>
                        <p>{selectedLanguage?.txt_the_dental_chairs_are_completely}</p>
                    </div>
                    <div className="tauclave-div">
                        <img src={tauclaveImg} alt="" />
                    </div>
                </div>
            </div>
        </div>
    )
}
export default SterilizationComponent